export var ElementType;
(function (ElementType) {
    ElementType[ElementType["Form"] = 0] = "Form";
    ElementType[ElementType["FormElement"] = 1] = "FormElement";
    ElementType[ElementType["FormElementFactory"] = 2] = "FormElementFactory";
    ElementType[ElementType["FormBackground"] = 3] = "FormBackground";
    ElementType[ElementType["FormBackgroundElement"] = 4] = "FormBackgroundElement";
    ElementType[ElementType["FormBackgroundElementFactory"] = 5] = "FormBackgroundElementFactory";
    ElementType[ElementType["Flow"] = 6] = "Flow";
    ElementType[ElementType["SimpleFlow"] = 7] = "SimpleFlow";
    ElementType[ElementType["FlowParameters"] = 8] = "FlowParameters";
    ElementType[ElementType["FlowElement"] = 9] = "FlowElement";
    ElementType[ElementType["FlowElementFactory"] = 10] = "FlowElementFactory";
    ElementType[ElementType["FlowSnippet"] = 11] = "FlowSnippet";
    ElementType[ElementType["Template"] = 12] = "Template";
    ElementType[ElementType["AgentFlow"] = 13] = "AgentFlow";
    ElementType[ElementType["AgentFlowElement"] = 14] = "AgentFlowElement";
    ElementType[ElementType["AgentFlowElementFactory"] = 15] = "AgentFlowElementFactory";
    ElementType[ElementType["AgentRule"] = 16] = "AgentRule";
    ElementType[ElementType["EmbeddedFlow"] = 17] = "EmbeddedFlow";
    ElementType[ElementType["DiagramTile"] = 18] = "DiagramTile";
    ElementType[ElementType["EmbeddedRule"] = 19] = "EmbeddedRule";
    ElementType[ElementType["Sync"] = 20] = "Sync";
    ElementType[ElementType["Async"] = 21] = "Async";
    ElementType[ElementType["Page"] = 22] = "Page";
    ElementType[ElementType["PageElement"] = 23] = "PageElement";
    ElementType[ElementType["PageElementFactory"] = 24] = "PageElementFactory";
    ElementType[ElementType["PrintPageTemplateElement"] = 25] = "PrintPageTemplateElement";
    ElementType[ElementType["Report"] = 26] = "Report";
    ElementType[ElementType["ReportElement"] = 27] = "ReportElement";
    ElementType[ElementType["ReportElementFactory"] = 28] = "ReportElementFactory";
    ElementType[ElementType["FolderAwareReport"] = 29] = "FolderAwareReport";
    ElementType[ElementType["EndForm"] = 30] = "EndForm";
    ElementType[ElementType["EndFormElement"] = 31] = "EndFormElement";
    ElementType[ElementType["IsInvalid"] = 32] = "IsInvalid";
    ElementType[ElementType["HasBreakingIssues"] = 33] = "HasBreakingIssues";
    ElementType[ElementType["Rule"] = 34] = "Rule";
    ElementType[ElementType["RuleStep"] = 35] = "RuleStep";
    ElementType[ElementType["RuleChain"] = 36] = "RuleChain";
    ElementType[ElementType["AgentRuleStep"] = 37] = "AgentRuleStep";
    ElementType[ElementType["InputData"] = 38] = "InputData";
    ElementType[ElementType["Archive"] = 39] = "Archive";
    ElementType[ElementType["TruthTable"] = 40] = "TruthTable";
    ElementType[ElementType["RuleTable"] = 41] = "RuleTable";
    ElementType[ElementType["Locked"] = 42] = "Locked";
    ElementType[ElementType["TextMerge"] = 43] = "TextMerge";
    ElementType[ElementType["UserControl"] = 44] = "UserControl";
    ElementType[ElementType["UserControlRepeater"] = 45] = "UserControlRepeater";
    ElementType[ElementType["JavaScriptDataControl"] = 46] = "JavaScriptDataControl";
    ElementType[ElementType["JavaScriptActionControl"] = 47] = "JavaScriptActionControl";
    ElementType[ElementType["JavaScriptPageControl"] = 48] = "JavaScriptPageControl";
    ElementType[ElementType["JavaScriptControlResource"] = 49] = "JavaScriptControlResource";
    ElementType[ElementType["MatrixRule"] = 50] = "MatrixRule";
    ElementType[ElementType["MatrixRuleStep"] = 51] = "MatrixRuleStep";
    ElementType[ElementType["SimpleFormElement"] = 52] = "SimpleFormElement";
    ElementType[ElementType["SimpleForm"] = 53] = "SimpleForm";
    ElementType[ElementType["Link"] = 54] = "Link";
    ElementType[ElementType["SimpleFormRepeater"] = 55] = "SimpleFormRepeater";
})(ElementType || (ElementType = {}));
;
